import { bindFirst, createSlatePlugin, KEYS } from '@udecode/plate';

import { setAlign } from './transforms';

/** Creates a plugin that adds alignment functionality to the editor. */
export const BaseTextAlignPlugin = createSlatePlugin({
  key: KEYS.textAlign,
  inject: {
    isBlock: true,
    nodeProps: {
      defaultNodeValue: 'start',
      nodeKey: 'align',
      styleKey: 'textAlign',
      validNodeValues: ['start', 'left', 'center', 'right', 'end', 'justify'],
    },
    targetPlugins: [KEYS.p],
    targetPluginToInject: ({ editor }) => ({
      parsers: {
        html: {
          deserializer: {
            parse: ({ element, node }) => {
              if (element.style.textAlign) {
                node[editor.getType(KEYS.textAlign)] = element.style.textAlign;
              }
            },
          },
        },
      },
    }),
  },
}).extendTransforms(({ editor }) => ({
  set: bindFirst(setAlign, editor),
}));
